import { v5 as uuidv5 } from "uuid";

export function getEndUserId(sourceId, namespace) {
  // Fallback namespace if not provided (create one using uuidv4() once and store it in .env)
  const NS = namespace || "3b241101-e2bb-4255-8caf-4136c566a962";
  const basis = String(sourceId || "")
    .trim()
    .toLowerCase();

  if (!basis) throw new Error("getEndUserId: sourceId is required");
  return uuidv5(basis, NS); // RFC 4122-compliant UUID v5
}
